import React from "react";
import Header from "../../SubComponents/Header";
import TendersComp from "../../SubComponents/SubAnnouncementsComp/tendersComp";
import Footer from "../../SubComponents/footer";
import "./style.css";
import Video from "../../assets/img/welcome.mp4";

const AnnouncementsMain = () => {
  return (
    <>
      <div className="position-relative white-text" style={{ height: "200px" }}>
        <video
          autoPlay
          loop
          muted
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        >
          <source src={Video} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
          }}
        ></div>
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            zIndex: 5000,
          }}
        >
          <Header />
        </div>
      </div>
      <main>
        <TendersComp />
      </main>
      <Footer />
    </>
  );
};

export default AnnouncementsMain;
